import { styled, ThemeDefinition } from "@vw-marketing/us-components";

export const StyledIconCtaContainer: any = styled.div`
  ${({ theme }: { theme: ThemeDefinition }) => {
    return `
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${theme.size.static100};
    `;
  }}
`;
